module.exports = __webpack_public_path__ + "media/images/bg-8f15882c759dfea3c162ecc4e900f913.jpg";